import { type UseVoucherHandler, type VoucherItem } from './type';
import { VoucherEmptyState } from './VoucherEmptyState';
import { VoucherTableHeader } from './VoucherTableHeader';
import { VoucherTableRow } from './VoucherTableRow';
interface VoucherTableProps {
  vouchers: VoucherItem[];
  onUseVoucher: UseVoucherHandler;
  isActivating: boolean;
}
export const VoucherTable = ({
  vouchers,
  onUseVoucher,
  isActivating
}: VoucherTableProps) => {
  return <div className="w-full overflow-x-auto" data-sentry-component="VoucherTable" data-sentry-source-file="VoucherTable.tsx">
      <div className="flex min-w-[620px] flex-col">
        <VoucherTableHeader data-sentry-element="VoucherTableHeader" data-sentry-source-file="VoucherTable.tsx" />

        {vouchers.length === 0 ? <VoucherEmptyState /> : <div className="flex w-full flex-col gap-xs">
            {vouchers.map(voucher => <VoucherTableRow key={voucher.id} voucher={voucher} onUseVoucher={onUseVoucher} isActivating={isActivating} />)}
          </div>}
      </div>
    </div>;
};